import React,{useEffect, useState, useCallback} from 'react'
import {TextField,Grid, Box,Button,FormHelperText} from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsEightSchema } from '../../Utils/Validations'
import FileValidations from '../FileValidation/FileValidations'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';

const DriveWithUsEight = ({ handleBack, handleComplete, driveUsData, setDriveUsData, }) => {
  const { CheckFile, fileError } = FileValidations()
  const [diamond_sticker_pic, setDiamond_sticker_pic] = useState()
  const [diamond_sticker_expiry, setDiamond_sticker_expiry] = React.useState(null);
  const [openImage, setOpenImage] = useState("")
  const [openModal, setOpenModal] = useState(false)
 
  const { handleSubmit, control, formState: { errors },setValue } = useForm({
    resolver: yupResolver(DriveUsEightSchema)
  })

const onSubmit = (data) => {
  if (Object.keys(fileError).length === 0) {
    console.log(data)
    setDriveUsData((prev) => ({ ...prev, diamond_sticker_pic: diamond_sticker_pic, diamond_sticker_expiry: diamond_sticker_expiry,diamond_sticker_number: data.diamond_sticker_number  }))

    handleComplete()
  }

  }

 useEffect(()=>{
  lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true,
  });
setValue("diamond_sticker_expiry",driveUsData.diamond_sticker_expiry||null)

 }, [driveUsData.diamond_sticker_expiry, setValue])

 const handleDateChange = useCallback((newValue, onChange) => {
   setDiamond_sticker_expiry(newValue);
   onChange(newValue);
 }, []);



  const onChangeFiles = (file, name) => {
    if (!file) {
      console.warn('No file selected');
      return;
    }

    // Use setTimeout to handle file processing asynchronously without blocking the form
    setTimeout(() => {
      try {
        CheckFile(file, name);
        
        if (name === "diamond_sticker_pic") {
          setDiamond_sticker_pic(file)
        }
      } catch (error) {
        console.error('Error handling file selection:', error);
      }
    }, 50); // Small delay for mobile devices
  }

  const handleOpenModal = (image) => {
    setOpenModal(true)
    setOpenImage(image)
    setTimeout(() => {
      $(document).ready(() => {
        $(`[href="${image}"]`).click();
      });
    }, 0);
  


}


  return (
    <div>
         {openModal && (
          <a
            href={`${openImage}`}
            data-lightbox="gallery"
            data-title="Image"
            style={{ display: 'none' }}
          >
            Open Image
          </a>
        )}
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0}}} >
            <Controller
            control={control}
            name="diamond_sticker_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
               <label>Diamond Sticker</label>
                <TextField 
                  fullWidth 
                  type="file" 
                  value={value} 
                  onBlur={onBlur} 
                  inputProps={{ 
                    onChange: (e) => { 
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e); 
                        onChangeFiles(file, "diamond_sticker_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }} 
                  error={errors?.diamond_sticker_pic || fileError?.diamond_sticker_pic} 
                  helperText={errors?.diamond_sticker_pic?.message || fileError?.diamond_sticker_pic?.message} 
                />
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}} >
                  <Box>
                <span className='image-detail' >Select any file or image</span><br />
                <span className='image-detail' >Maximum file size: 50MB</span>

                  </Box>
                  <img src='/driver_forms/assets/images/DIAMOND STICKER.jpg' style={{height:50}} onClick={()=>handleOpenModal("/driver_forms/assets/images/DIAMOND STICKER.jpg")}  />
                </Box>
                
              </>
            )}
          />
                
      
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}}>
        <Controller
            control={control}
            name="diamond_sticker_expiry"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
               <label>Diamond Sticker Expiry</label>
               <DatePicker
                  sx={{width:"100%"}}
                  className='date-picker'
                  value={value}
                  onChange={(newValue) => handleDateChange(newValue, onChange)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errors.diamond_sticker_expiry,
                      helperText: errors.diamond_sticker_expiry?.message
                    }
                  }}
                />
               
               {errors.diamond_sticker_expiry?<FormHelperText component="p" sx={{color:"#d32f2f",px:1.5}} >{errors.diamond_sticker_expiry?.message}</FormHelperText>:null}
              </>
            )}
          />
        
       
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}}>
        <Controller
            control={control}
            name="diamond_sticker_number"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
               <label>Diamond Sticker Number</label>
                <TextField fullWidth type="text" value={value} onBlur={onBlur} onChange={onChange} error={errors?.diamond_sticker_number } helperText={errors?.diamond_sticker_number?.message} on />
               
              </>
            )}
          />
        
       
        </Grid>
       
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:3 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsEight